let initSwatchLister = () => {
    $(".change-color .radio__holder input").on('click', function(){
        const color = $(this).val();
        let staticImage = true;
        let target = $(this).closest('.product_target');
        let data = $( target ).data('images-by-color');
        data.forEach(element => {
            let single = element.split('||');
            if(color === single[0]){
                // console.log(single[1]);
                if(staticImage){
                    staticImage = false;
                    target.find('.product_target_anchor').css({
                        backgroundImage: `url(${single[1]})`
                    })
                }else{
                    target.find('.product_target_anchor span').css({
                        backgroundImage: `url(${single[1]})`
                    })
                }
            }
        });
    });

    Array.prototype.forEach.call($(".change-color"), element => {
        $(element).find(".radio__holder input:eq(0)").trigger('click');
    });
}

(function() {
    if( document.querySelector('.change-color') ) {
        initSwatchLister();
    }
})()

module.exports = {

};
  



// WEBPACK FOOTER //
// ../assets/js/product_colors.js